<template lang="">
  <el-container class="on-test">
    <el-header>
      <top-bar :key="'reading-start'" :limit-minutes="60" :hide-time="paper.paperType === '0'" :test-type="'Reading'" @handle-finish="handleFinish" />
    </el-header>
    <el-main>
      <section class="app-main">
        <el-row style="margin-top:20px; padding-left:20px;">
          <el-col :span="24">
            <div class="text-left">
              <h5>IELTS Academic Reading</h5>
              <p>Time: 1 hour</p>
              <h5>INSTRUCTIONS TO CANDIDATES</h5>
              <ul>
                <li>Answer <strong>all</strong> the questions.</li>
                <li>You can change your answers at any time during the test.</li>
              </ul>
              <h5>INFORMATION FOR CANDIDATES</h5>
              <ul>
                <li>There are 40 questions in this test.</li>
                <li>Each question carries one mark.</li>
                <li>The test clock will show you when there are 10 minutes and 5 minutes remaining.</li>
              </ul>
            </div>
            <div class="text-center">
              <p>Do not click 'Start test' until you are told to do so.</p>
              <el-button class="btn bc-button" @click="$emit('readingNextStep','ReadingTestView')">Start test</el-button>
            </div>
          </el-col>
        </el-row>
      </section>
    </el-main>
    <Note :text="note" />
  </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TopBar from '@/components/TopBar'
import Note from '@/components/Note'

export default {
  name: 'ReadingPage',
  components: { TopBar, Note },
  emits: ['readingNextStep'],
  data() {
    return {
      note: 'Please click the “Start test” button to start the familiarisation test, in your real IELTS test there will be an invigilator in the room to advise when to do this.'
    }
  },
  computed: {
    ...mapGetters({ paper: 'paperInfo' })
  },
  methods: {
    handleFinish(val) {
      this.$emit('readingNextStep', val)
    }
  }
}
</script>
<style lang="scss" scoped>
h5{
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  margin-top: 0;
  line-height: 1.2;
}
.btn.bc-button {
    margin: 0 auto;
    background-color: transparent;
    color: #283e53;
    font-weight: bold;
    border: none;
    box-shadow: 0 2px 2px grey;
}
</style>
